module.exports = __webpack_public_path__ + "static/travel_insurance.aef4e07c.jpg";